import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
export default function LinkCell(_ref) {
  var original = _ref.original,
    value = _ref.value,
    getHref = _ref.column.getHref;
  return /*#__PURE__*/React.createElement(Link, {
    to: getHref(original),
    className: "dm-table__link auto-table-link"
  }, original.title || /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "@dm/components.table.unknown-link"
  }));
}